<template>

  <section class="red-background relative timeline-white">
    
      <div class="container section-large text-with-image">

        <div class="narrow-text">
          <h2>Key dates</h2>
            <q-timeline class="mts container " :layout="layout" side="right" color="white">
              <q-timeline-entry
                title="Call for contributions opens"
                subtitle="Monday 6th February"
                icon="campaign"
                side="right"
              >
              </q-timeline-entry>
              <!-- <q-timeline-entry
                title="Registration opens"
                subtitle="Monday 27th February"
                icon="lock_open"
                side="right"
              >
              </q-timeline-entry> -->
              <q-timeline-entry
                title="Call for contributions closes"
                subtitle="Friday 31st March"
                icon="block"
                side="right"
              >
              </q-timeline-entry>
              <q-timeline-entry
                title="Successful contributors informed"
                subtitle="Wednesday 10th May"
                side="right"
                icon="outgoing_mail"
              >
              </q-timeline-entry>
              <q-timeline-entry
                title="Registration opens"
                subtitle="Monday 22nd May"
                side="right"
                icon="block"
              >
              </q-timeline-entry>
              <q-timeline-entry
                title="Conference opens"
                subtitle="Wednesday 14th June"
                icon="today"
                side="right"
              >
              </q-timeline-entry>
               <q-timeline-entry heading>Wednesday 14th June: conference starts</q-timeline-entry>
              <q-timeline-entry
                title="Conference starts"
                subtitle="9:30am"
                icon="schedule"
                side="right"
              >
              </q-timeline-entry>
              <q-timeline-entry
                title="Conference ends"
                subtitle="4:00pm"
                icon="schedule"
                side="right"
              >
              </q-timeline-entry>
          
          </q-timeline>
        </div>

        <div class="text-with-image-img"><img src="../assets/timeline.svg" alt=""></div>
      </div>
      
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { useQuasar } from 'quasar'
import { computed } from 'vue'

const $q = useQuasar()

const layout = computed(() => {
  return $q.screen.lt.sm ? 'dense' : ($q.screen.lt.md ? 'comfortable' : 'loose')
})

</script>